import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { user } from "@/types/api/user.api";
import type { userFormData } from "../userFormModal/types.props";
import type { parsedApiError } from "@/types/api/errors.api";
import type { useUserModalProps } from "./types.props";

export const useUserModal = ({
    create,
    update,
    refreshStats,
}: useUserModalProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState<user | null>(null);
    const [apiError, setApiError] = useState<parsedApiError | null>(null);
    const navigate = useNavigate();

    const handleOpenModal = (user: user | null = null) => {
        setEditingUser(user);
        setApiError(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingUser(null);
        setApiError(null);
    };

    const handleSubmit = async (formData: userFormData) => {
        setApiError(null);
        try {
            const institutionName = formData.institution?.name || null;

            const payload = {
                ...formData,
                institution: formData.role === "Facilitador" ? null : institutionName,
            };

            if (editingUser && !payload.password) {
                delete payload.password;
            }

            const apiPayload = payload as any;

            if (editingUser) {
                await update(editingUser.id, apiPayload);
            } else {
                await create(apiPayload);
            }

            await refreshStats();
            handleCloseModal();
        } catch (error) {
            setApiError(error as parsedApiError);
        }
    };

    const handleAssignSimulations = (user: user) => {
        navigate(`/facilitator-panel/user-management/${user.id}/assignments`);
    };

    return {
        isModalOpen,
        editingUser,
        apiError,
        handleOpenModal,
        handleCloseModal,
        handleSubmit,
        handleAssignSimulations,
    };
};
